import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  const beliefs = [
    {
      title: "Authenticity",
      description: "Every recipe tells a story. Our cakes are made with real ingredients and real heart."
    },
    {
      title: "Celebration", 
      description: "Whether it's a birthday, a market day, or just a sweet craving, we make every moment special."
    },
    {
      title: "Connection",
      description: "Baking helps us connect with ourselves, with our roots, and with people from all over the world who are curious to discover something new."
    },
    {
      title: "Creativity",
      description: "Inspired by global trends, we love experimenting with seasonal flavours, artistic decoration, and fusion desserts that surprise and delight."
    }
  ];

  return (
    <div className="about-page">
      {/* Background Elements */}
      <div className="about-background">
        <div className="background-shape shape-1"></div>
        <div className="background-shape shape-2"></div>
        <div className="background-shape shape-3"></div>
      </div>

      <div className="about-container">
        {/* Hero Section */}
        <section className="about-hero">
          <h1 className="about-main-title">Our Story</h1>
          <p className="about-subtitle">Sharing memories, culture, and connection through authentic Venezuelan desserts</p>
        </section>

        {/* Story Content */}
        <section className="story-section">
          <div className="story-content">
            <div className="story-card">
              <h2 className="story-title">The Beginning</h2>
              <p className="story-text">
                Panela Crumbs was born from a sweet idea in 2021, but it wasn't until after 2022 that our dream truly began to take shape. Inspired by the rich flavours of Latin America and a love for baking, we started sharing our cakes across Nottingham.
              </p>
              <p className="story-text">
                By 2023, we proudly made our debut at local city markets, bringing our signature Tres Leches cakes and other Latin-inspired desserts to the community.
              </p>
            </div>

            <div className="story-card">
              <h2 className="story-title">Our Mission</h2>
              <p className="story-text">
                Founded by a 28-year-old Venezuelan living in the UK for the past six years, Panela Crumbs is the result of a heartfelt journey. My love for baking began in my aunt's kitchen, where I discovered the joy and passion that go into every homemade cake.
              </p>
              <p className="story-text">
                What started as a personal craving became a passion project, and now a home bakery that celebrates Latin-inspired flavours, handcrafted quality, and emotional connection.
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2 className="values-title">What We Believe</h2>
          <div className="values-grid">
            {beliefs.map((belief, index) => (
              <div key={index} className="value-card">
                <h3 className="value-name">{belief.title}</h3>
                <p className="value-description">{belief.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Closing Quote */}
        <section className="quote-section">
          <div className="quote-card">
            <p className="quote-text">
              "In a world that's always rushing, we invite you to slow down, take a bite, and feel at home wherever you are."
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage; 